<template>
	<div class="tpbc-bootstrap-container">
		<div class="row">
			<div class="col-md-6">
				<form action="#" @submit.prevent="calculate">
					<div class="form-group">
						<label for="">How many pages are in your book?</label>
						<input type="text" class="form-control" v-model="pages">
					</div>
					<div class="form-group">
						<label for="">Please select your paper type</label>
						<select v-model="paperType">
							<option value="0">Select Paper Type</option>
							<option v-for="type in paperTypes" :value="type.id">{{ type.label }}</option>
						</select>
					</div>
					<div class="form-group">
						<button type="submit" class="btn btn-success">Calculate Spine Width</button>
						<button class="btn btn-info" @click.prevent="clearValues">Clear values</button>
					</div>
				</form>

				<div class="form-group">
					<label for="">Spine Width</label>
					<input type="text" :disabled="true" :value="spineWidth">
				</div>
			</div>
		</div>
	</div>
</template>


<script>
	export default {
		data() {
			return {
				pages: '',
				paperType: 0,
				paperTypes: [{
					id: 1,
					value: 520,
					label: "White Offset Smooth 50#"
				}, {
					id: 2,
					value: 470,
					label: "White Offset Vellum 50#"
				}, {
					id: 3,
					value: 434,
					label: "White Offset Smooth 60#"
				}, {
					id: 4,
					value: 390,
					label: "White Offset Vellum 60#"
				}, {
					id: 5,
					value: 390,
					label: "White Offset Smooth 70#"
				}, {
					id: 6,
					value: 530,
					label: "Recycled White Offset Smooth 50#"
				}, {
					id: 7,
					value: 526,
					label: "Opaque White Offset Uncoated Smooth 50#"
				}, {
					id: 8,
					value: 440,
					label: "Opaque White Offset Uncoated Smooth 60#"
				}, {
					id: 9,
					value: 500,
					label: "Natural Offset Uncoated Eggshell 50#"
				}, {
					id: 10,
					value: 400,
					label: "Natural Offset Uncoated Antique 50#"
				}, {
					id: 11,
					value: 360,
					label: "Recycled Natural Offset Antique 55#"
				}, {
					id: 12,
					value: 400,
					label: "Groundwood Offset Natural high bulk 45#"
				}, {
					id: 13,
					value: 490,
					label: "White Matte Text 70#"
				}, {
					id: 14,
					value: 410,
					label: "White Matte Text 80#"
				}, {
					id: 15,
					value: 330,
					label: "White Matte Text 100#"
				}, {
					id: 16,
					value: 270,
					label: "White Matte Text High Bulk 100#"
				}, {
					id: 17,
					value: 620,
					label: "White Gloss Enamel Text Smooth 70#"
				}, {
					id: 18,
					value: 568,
					label: "White Gloss Enamel Text Smooth 80#"
				}, {
					id: 19,
					value: 438,
					label: "White Gloss Enamel Text Smooth 100#"
				}],
				spineWidth: 0,
			}
		},

		mounted() {
			// Ajax retrieve from database your paper types
		},

		methods: {
			calculate() {
				var difference = ((this.pages / this.paperTypes[this.paperType-1].value) + 0.02);

				this.spineWidth = difference.toFixed(3);
				
				// Code from CHG to calculate spine width
                // mypagecount = form.pages.value;
                // mypapertype = form.papertype.value;
                // additionalwidth = 0.02;
                // difference = ((mypagecount / mypapertype) + additionalwidth);
                // form.spinewidth.value = difference.toFixed(3);
            },

            clearValues() {
            	this.pages = '';
            	this.paperType = 0;
            	this.spineWidth = 0;
            }
		}
	}
</script>


// WEBPACK FOOTER //
// SpineWidthCalculator.vue?725cfd75